import Catalogs from "./catalogs";

export default Catalogs;
